/*eslint-disable */
const $ = window.jQuery = require('jquery');

import axios from 'axios';
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import moment from 'moment';
import root from '@/_helpers/roots';
import sharedModelPopup from '../shared-models/index.vue';
import toast from '@/services/toast';

let modelFiltersApiUrl = root.modelsForAITaskApiUrl.link;

export default {
  name: 'created-models-list',
  components: {
    'shared-model-popup' : sharedModelPopup
  },
  props: [],
  data () {
    return {
      trainedAlgoList:null,
      trainedAlgoListResults:[],
      pubModelId:'',
      publicModelPopup:false,
      userDetails:null,
      updateModelName:'',
      updateModelNameId:'',
      updateModelNameState:false,
      sharedModelInfo:null,
      sharedModelPopup:false,
      submitted:false,
      algoListForClassification:[
        'Logistic Regression',
        'Decision Tree Classifier',
        'Random Forest Classifier',
        'Gradient Boosting Classifier',
        'Support Vector Classifier',
        'Gaussian Naive Bias',
        'K-Neighbors Classifier'
      ],
      algoListForRegression:[
        'Linear Regression',
        'Decision Tree Regressor',
        'Random Forest Regressor',
        'Gradient Boosting Regressor',
        'Support Vector Regressor',
        'K-Neighbors Regressor'
      ],
      is_type:'',
      is_algorithm:'',
      is_disease:'',
      is_year:'',
      is_month:'',
      is_month_name:'',
      diseaseListResults:[],
      userLoading:false,
      isSelectedAlgoData:[],
      filterEnabledState:false
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserDetailsFun(){
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data;
      return
    },
  },
  mounted () {
    this.getSelfUserDetailsFun
    this.getTrainedModelsListFunc()
    bus.$on('sharedModelPopupBus', (data) => {
      this.sharedModelPopup = data
    })
    this.$store.dispatch('getDiseaseListForAiDashFun').then((res) => {
      this.diseaseListResults = res.data.data.results
    })
  },
  methods: {
    clearFiltersMethod(){
      this.filterEnabledState = false
      this.is_type = '' 
      this.is_algorithm = ''
      this.is_disease = ''
      this.is_year = ''
      this.is_month_name = ''
      this.is_month = ''
      this.userLoading = true
      this.$store.dispatch('getModelListForAITaskFun').then((res) => {
        this.trainedAlgoList = res.data.data
        this.trainedAlgoListResults = this.trainedAlgoList.results 
        this.userLoading = false
      }).catch((err) => {
        this.userLoading = false
      })
    },
    filterByIsTypeMethod(val){
      this.filterEnabledState = true
      this.is_type = val
      this.userLoading = true
      if(val == 'classification'){
        this.isSelectedAlgoData = this.algoListForClassification
      }else{
        this.isSelectedAlgoData = this.algoListForRegression
      }
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.trainedAlgoList = response.data.data
        this.trainedAlgoListResults = this.trainedAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsAlgoMethod(val){
      this.filterEnabledState = true
      this.is_algorithm = val
      this.userLoading = true
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.trainedAlgoList = response.data.data
        this.trainedAlgoListResults = this.trainedAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsDiseaseMethod(val){
      this.filterEnabledState = true
      this.is_disease = val
      this.userLoading = true
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.trainedAlgoList = response.data.data
        this.trainedAlgoListResults = this.trainedAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsYearMethod(val){
      this.filterEnabledState = true
      this.is_year = val
      this.userLoading = true
      axios.get(modelFiltersApiUrl + '?is_year=' + this.is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.trainedAlgoList = response.data.data
        this.trainedAlgoListResults = this.trainedAlgoList.results
        this.userLoading = false
      })
    },
    filterByIsMonthMethod(name, val){
      this.filterEnabledState = true
      this.is_month_name = name
      this.is_month = val
      this.userLoading = true
      const is_year = this.is_year || moment(new Date()).format('YYYY')
      axios.get(modelFiltersApiUrl + '?is_year=' + is_year + '&is_month=' + this.is_month + '&is_disease=' + this.is_disease + '&is_type=' + this.is_type + '&is_algorithm=' + this.is_algorithm).then((response) => {
        this.trainedAlgoList = response.data.data
        this.trainedAlgoListResults = this.trainedAlgoList.results
        this.userLoading = false
      })
    },
    getTrainedModelsListFunc() {
      this.$store.dispatch('getModelListForAITaskFun').then((res) => {
        this.trainedAlgoList = res.data.data
        this.trainedAlgoListResults = this.trainedAlgoList.results 
      })
    },
    makeModelPublicMethod(modelId){
      console.log(modelId);
      this.pubModelId = modelId
      this.publicModelPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
    clodesModelPublicPopupMethod(){
      this.pubModelId = ''
      this.publicModelPopup = false
      $('body').removeClass('body_right_scroll_remove')
    },
    userStatusUpdatedFun(userStatus){
      var is_public = userStatus
      if(userStatus == false){
        is_public = true
      }else{
        is_public = false
      }
      // console.log(userStatus, is_public, "User Status CHecking")
      let data = new FormData();
      data.append('is_public', is_public);
      this.$store.dispatch('updateProfileFun', data)
        .then((res) => {
          this.getTrainedModelsListFunc();
          toast.success(res.data.msg);
        }).catch((err) => {
          toast.error(err.data.user_msg || err.data.data.email);
        })
      return;
    },
    modelNameUpdatePopupOpenFun(modelId, ModelName){
      this.updateModelName = ModelName
      this.updateModelNameId = modelId
      this.updateModelNameState = true
      $('body').addClass('body_right_scroll_remove')
    },
    updateModelNameaBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            name : this.updateModelName
          }
          this.$store.dispatch('updateModelDetailsByIDForAIFun',{data:{data:data,id:this.updateModelNameId}})
            .then((res) => {  
              this.getTrainedModelsListFunc();
              toast.success(res.data.msg);
              this.submitted =  false;
              this.closeUpdateModelNamePopup();
            }).catch((err) => {
              this.submitted =  false;
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeUpdateModelNamePopup(){
      this.updateModelNameState = false
      $('body').removeClass('body_right_scroll_remove')
    },
    sharedModelPopupMethod(modelId){
      this.sharedModelInfo = modelId
      this.sharedModelPopup = true
      $('body').addClass('body_right_scroll_remove')
    },
  },
  watch:{
    getSelfUserDetailsFun(){
      return this.$store.getters.acUserDetailsStateGetters;
    },
  }
}